module.exports = __webpack_public_path__ + "static/media/overview1_1.f72875bc.png";